import type { SubnavMenuItemId } from "domains/nav/types/subnavMenuItemId";

export enum HostCommand {
  AUTH_SET_TOKEN = "AUTH_SET_TOKEN",
  SET_LANGUAGE = "SET_LANGUAGE",
  SET_PLATFORM = "SET_PLATFORM",
  SET_THEME = "SET_THEME",
  SUBNAV_ITEM_ACTIVE_CLEAR = "SUBNAV_ITEM_ACTIVE_CLEAR",
  SUBNAV_ITEM_ACTIVE_SET = "SUBNAV_ITEM_ACTIVE_SET",
  SUBNAV_ITEM_DATA_UPDATE = "SUBNAV_ITEM_DATA_UPDATE",
  SUBNAV_SET_DATA = "SUBNAV_SET_DATA",
}

export type HostCommandPayloads = {
  [HostCommand.AUTH_SET_TOKEN]: { value: string | null };
  [HostCommand.SET_LANGUAGE]: { value: GlobalNavLanguage };
  [HostCommand.SET_PLATFORM]: {
    language?: GlobalNavLanguage;
    platform: GlobalNavPlatform;
    theme?: GlobalNavTheme;
    token?: string | null;
  };
  [HostCommand.SET_THEME]:
    | { all: GlobalNavTheme; navbar?: GlobalNavTheme; subnav?: GlobalNavTheme }
    | { all?: GlobalNavTheme; navbar: GlobalNavTheme; subnav?: GlobalNavTheme }
    | { all?: GlobalNavTheme; navbar?: GlobalNavTheme; subnav: GlobalNavTheme };
  [HostCommand.SUBNAV_ITEM_ACTIVE_SET]: { value: string };
  [HostCommand.SUBNAV_ITEM_DATA_UPDATE]: SubnavMenuItemInput;
  [HostCommand.SUBNAV_SET_DATA]: {
    join_us_label?: string;
    public_menu_items: SubnavMenuItemInput[] | null;
    sign_in_label?: string;
    theme?: GlobalNavTheme;
    user_menu_items: SubnavMenuItemInput[] | null;
  };
};

type GlobalNavLanguage = "en" | "es" | "ja" | "zh";

type GlobalNavPlatform =
  | "DM_PORTAL"
  | "FORUM_SPACES"
  | "LOCALHOST"
  | "MFE_TEST"
  | "MY_FORUM"
  | "PUBLIC_SITE"
  | "SI"
  | "TOPLINK";

type GlobalNavTheme = "DARK" | "DARK_TRANSPARENT" | "LIGHT" | "LIGHT_TRANSPARENT";

export type SubnavMenuItemInput = { id: SubnavMenuItemId } & (
  | ({ active?: boolean; divider?: false; emphasized?: boolean; title: string } & (
      | { icon?: SubnavMenuItemIcon; option?: undefined }
      | { icon?: undefined; option?: string }
    ) &
      (
        | { action: string; url?: undefined; children?: undefined }
        | { action?: undefined; url: string; children?: undefined }
        | { action?: undefined; url?: undefined; children: SubnavMenuItemInputWithoutChildren[] }
      ))
  | { divider: true }
);

export type SubnavMenuItemInputWithoutChildren = { id: string } & (
  | ({ active?: boolean; divider?: false; emphasized?: boolean; title: string } & (
      | { icon?: SubnavMenuItemIcon; option?: undefined }
      | { icon?: undefined; option?: string }
    ) &
      ({ action: string; url?: undefined } | { action?: undefined; url: string }))
  | { divider: true }
);

export enum SubnavMenuItemIcon {
  CHEVRON_DOWN = "CHEVRON_DOWN",
  CHEVRON_RIGHT = "CHEVRON_RIGHT",
  DARK = "DARK",
  FULLSCREEN = "FULLSCREEN",
  LIGHT = "LIGHT",
}
